import { render, staticRenderFns } from "./ShareResults.vue?vue&type=template&id=2938ed3a&scoped=true&"
import script from "./ShareResults.vue?vue&type=script&lang=ts&"
export * from "./ShareResults.vue?vue&type=script&lang=ts&"
import style0 from "./ShareResults.vue?vue&type=style&index=0&id=2938ed3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938ed3a",
  null
  
)

export default component.exports